import React, { useState, useEffect } from "react";
import "./css/navbar.css";
// import logo from '../assets/images/round_logo.png';
import logo from '../assets/images/Seatech.jpg';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="navContainer">
        {/* Logo */}
        <div className="navLogo">
          <img src={logo} alt="Logo" />
          {/* <h2>SEATECH</h2> */}
        </div>

        {/* Desktop Menu */}
        <ul className="navMenu">
          <li className="navItem">
            <a href="#home" className="navLink">Home</a>
          </li>
          <li className="navItem">
            <a href="#about" className="navLink">About</a>
          </li>
          <li className="navItem">
            <a href="#services" className="navLink">Services</a>
          </li>
          <li className="navItem">
            <a href="#team" className="navLink">Team</a>
          </li>
          <li className="navItem">
            <a href="#portfolio" className="navLink">Portfolio</a>
          </li>
          <li className="navItem">
            <a href="#equipments" className="navLink">Equipments</a>
          </li>
          <li className="navItem">
            <a href="#map" className="navLink">Location</a>
          </li>
        </ul>

        {/* Contact Button */}
        <div className="navContact">
          <a href="#contact" className="contactBtn">Contact</a>
        </div>


        {/* Mobile Menu Toggle */}
        <div className={`navToggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Mobile Menu */}
        <div className={`mobileMenu ${isMenuOpen ? 'active' : ''}`}>
          <ul className="mobileNavMenu">
            <li className="mobileNavItem">
              <li className="mobileNavItem">
                <a href="#about" className="mobileNavLink" onClick={closeMenu}>About</a>
              </li>
              <a href="#services" className="mobileNavLink" onClick={closeMenu}>Services</a>
            </li>
            <li className="mobileNavItem">
              <a href="#projects" className="mobileNavLink" onClick={closeMenu}>Projects</a>
            </li>
            <li className="mobileNavItem">
              <a href="#contact" className="mobileContactBtn" onClick={closeMenu}>
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;